const configService = {
  pendo: {
    default:'c6883035-3580-40ca-4d9f-47c96a6940c9'
  },
  instana: {
    default: '76Vh7kCPRQGGupkQz8E6vA',
    prod: 'NRC-xX43RmOluY9ce6qU5g'
  },
  loggly: {
    default: 'a01b27d8-6745-4d03-bdfd-a33944281ece',
    prod: '8240a0a9-d319-4768-aae7-f603f95bbabb'
  },
  arroyo: {
    default: 'https://analytic-events-dev.dataservices-mml.cloud',
    prod: 'https://analytic-events-prod.dataservices-mml.cloud'
  }
};

const config = {
  achieve: {
    default: {
      pendo: configService.pendo.default,
      instana: configService.instana.default,
      loggly: configService.loggly.default,
      arroyo: configService.arroyo.default
    },
    prod: {
      pendo: configService.pendo.default,
      instana: configService.instana.prod,
      loggly: configService.loggly.prod,
      arroyo: configService.arroyo.prod
    },
    intl: {
      instana: configService.instana.default,
      loggly: configService.loggly.prod
    }
  },
  other: {
    default: {
      // pendo: configService.pendo.default, // For enabling pendo "locally"
      instana: configService.instana.default,
      loggly: configService.loggly.default
    },
    prod: {
      instana: configService.instana.prod,
      loggly: configService.loggly.prod
    }
  }
};

export default config;